import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
import {
  BaseTableDefinitionFactory,
  ColumnFilterType,
  IndexType,
  ProfilePromiseActionService,
} from "shared/cubiq-services";
import { BfxColDef, TableDefinition } from "shared/cubiq-services/model/TableDefinition";
import { Injectable } from "@angular/core";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OrderAuditTableDefinitionFactory extends BaseTableDefinitionFactory {
  constructor(profileService: ProfilePromiseActionService) {
    super(profileService);
  }

  public override createDef(): TableDefinition {
    super.createDef();
    let col: BfxColDef;

    let td = new TableDefinition("rowId", "actionTime");
    col = this.createActionTimeColumn();
    td.addColumn(col);
    col = this.createOrderActionColumn();
    td.addColumn(col);
    col = this.createCommentsColumn();
    td.addColumn(col);
    col = this.createUserIdColumn();
    td.addColumn(col);
    col = this.createOrderStatusColumn();
    td.addColumn(col);

    // Default sort by Action Time descending
    td.setDefaultSort(1, "desc");
    return td;
  }

  protected createActionTimeColumn() {
    const col = this.createDefaultColumn("Date", "actionTime", this.nineWs);
    col.indexType = IndexType.Integer;
    col.valueFormatter = (params) => params.data.actionTimeStr;
    this.checkRestore(col);
    return col;
  }

  protected createOrderActionColumn() {
    const col = this.createDefaultColumn("Action", "orderAction", this.nineWs);
    this.checkRestore(col);
    return col;
  }

  protected createCommentsColumn() {
    const col = this.createDefaultColumn("Comments", "commentsDisplay", this.thirteenWs);
    col.cellClass = "audit-comment";
    col.showTooltip = true;
    this.checkRestore(col);
    return col;
  }

  protected createUserIdColumn() {
    const col = this.createDefaultColumn("User ID", "userStr", this.eightWs);

    this.checkRestore(col);
    return col;
  }

  protected createOrderStatusColumn() {
    const col = this.createDefaultColumn("Order Status", "orderStatus", this.nineWs);
    this.checkRestore(col);
    return col;
  }

  protected createDefaultColumn(headerName: string, fieldId: string, width: number): BfxColDef {
    let col: BfxColDef = { suppressMenu: true };
    col.headerName = headerName;
    col.field = fieldId;
    col.minWidth = 50;
    col.width = width;
    col.indexType = IndexType.String;
    col.columnFilterType = ColumnFilterType.NONE;
    col.sortable = true;
    return col;
  }

  protected checkRestore(col: BfxColDef): void {
    if (!this.restoreFromConfig(col)) {
      col.hide = false;
      col.position = this.position.next();
    }
  }

  public override getBlotterType(): CubiqTS.BlotterType {
    return null;
  }

  public getAssetClass(): CubiqTS.AssetClass {
    return CubiqTS.AssetClass.FIX;
  }
}
